export const VIRTUAL_PROVIDER = "VIRTUAL" as const;
/** @deprecated ReturnBear is retired; superseded by {@link VIRTUAL_PROVIDER}. Parses stored dropoffs only. */
export const RETURN_BEAR_PROVIDER = "RETURN_BEAR" as const;
export const BLUE_YONDER_PROVIDER = "BLUE_YONDER" as const;
export const HAPPY_RETURNS_PROVIDER = "HAPPY_RETURNS" as const;

export const dropoffProviderType = [
  VIRTUAL_PROVIDER,
  RETURN_BEAR_PROVIDER,
  BLUE_YONDER_PROVIDER,
  HAPPY_RETURNS_PROVIDER,
] as const;
export type DropoffProviderType = (typeof dropoffProviderType)[number];
export const DropoffProviderType = dropoffProviderType;

const merchantFacingProviderNames: Record<DropoffProviderType, string> = {
  VIRTUAL: "Virtual",
  /** @deprecated ReturnBear is retired; no merchant-facing surface offers it. */
  RETURN_BEAR: "ReturnBear",
  BLUE_YONDER: "FedEx Easy Returns",
  HAPPY_RETURNS: "Happy Returns",
};

export function getMerchantFacingProviderName(
  provider: DropoffProviderType,
): string {
  return merchantFacingProviderNames[provider];
}

export const DEFAULT_DROPOFF_RADIUS_MILES = 50;

export const CUSTOM_DROPOFF_SHIPMENT_ID_PREFIX = "custom-dropoff/";

/**
 * Flat-rate fee (USD) when no fee is stored on the draft return. `null` means
 * the fee resolves through another path (e.g. ReturnBear's rate table).
 */
export const defaultDropoffFeeUsd = {
  VIRTUAL: 5,
  BLUE_YONDER: 6,
  /** @deprecated ReturnBear is retired; no new dropoffs quote this fee. */
  RETURN_BEAR: null,
  /** Happy Returns has no default fee; pricing is negotiated per merchant. */
  HAPPY_RETURNS: null,
} as const satisfies Record<DropoffProviderType, number | null>;

export const DEFAULT_VIRTUAL_DROPOFF_FEE_USD = defaultDropoffFeeUsd.VIRTUAL;
export const DEFAULT_BLUE_YONDER_DROPOFF_FEE_USD =
  defaultDropoffFeeUsd.BLUE_YONDER;
